import * as React from 'react';
import { css } from 'aphrodite';
import { t } from '@citrite/translate';
import {
	Button,
	LoadingIconPrimary,
	withModals,
	WithModalsProps,
} from '@citrite/web-ui-component';
import { UserAccountData } from '@citrite/workspace-ui-platform';
import { useBrowserExtensionPrompt } from 'App/Tile/useBrowserExtensionPrompt';
import { restartDesktop } from 'Components/ResourceTile/restartDesktop';
import {
	WithWorkspaceConfiguration,
	withWorkspaceConfiguration,
} from 'Configuration/withWorkspaceConfiguration';
import {
	withResourceContext,
	WithResourceContextProps,
} from 'Workspace/ResourceProvider';
import { Resource } from 'Workspace/ResourceProvider/resourceTypes';
import { useUserContext } from 'Workspace/UserContext';
import { styles } from './RestartDesktopButton.styles';

export interface Props
	extends WithResourceContextProps,
		WithWorkspaceConfiguration,
		WithModalsProps {
	resource: Resource;
	userDetails: UserAccountData;
	canShowBrowserExtensionPrompt: boolean;
}

class __RestartDesktopButton extends React.Component<Props> {
	public render() {
		const { resourceContext, resource } = this.props;
		const restarting = resourceContext.desktopRestartInProgressIds.includes(resource.id);
		return restarting ? (
			<div className={css(styles.loadingContainer)}>
				<div className={css(styles.loadingIcon)}>
					<LoadingIconPrimary size={18} />
				</div>
				{t('Workspace:restart_in_progress')}
			</div>
		) : (
			<Button.TextPrimary onClick={this.restartDesktop}>
				{t('Workspace:restart_desktop_modal.restart')}
			</Button.TextPrimary>
		);
	}

	private restartDesktop = () => {
		const {
			resource,
			resourceContext,
			workspaceConfiguration,
			showModal,
			userDetails,
			canShowBrowserExtensionPrompt,
		} = this.props;
		restartDesktop(resource, { resourceContext }, workspaceConfiguration, {
			userDetails,
			canShowBrowserExtensionPrompt,
			showModal,
		});
	};
}

const _RestartDesktopButton = (
	props: Omit<Props, 'userDetails' | 'canShowBrowserExtensionPrompt'>
) => {
	const { userDetails } = useUserContext();
	const canShowBrowserExtensionPrompt = useBrowserExtensionPrompt();
	return (
		<__RestartDesktopButton
			{...props}
			userDetails={userDetails}
			canShowBrowserExtensionPrompt={canShowBrowserExtensionPrompt}
		/>
	);
};

export const RestartDesktopButton = withWorkspaceConfiguration(
	withResourceContext(withModals(_RestartDesktopButton))
);
